import Resource from '../../resource';
import request from "../../../utils/request";

class Settings extends Resource {
    constructor() {
        super('settings');
    }

    put(id, query) {
        return request({
            url: `/settings${id?'/'+id:''}`,
            method: 'put',
            data: query,
        })
    }
    editSupplementarySubjects(id, query) {
        return request({
            url: `/settings${id?'/'+id:''}`,
            method: 'put',
            data: query,
        })
    }
    get(id) {
        return request({
            url: `/settings${id?'/'+id:''}`,
            method: 'get',
        })
    }
    enrollmentSetting(id, query) {
        return request({
            url: `/settings/enrollment-setting${id?'/'+id:''}`,
            method: 'put',
            data: query,
        })
    }
    graduationCertificateSetting(id, query) {
        return request({
            url: `/settings/graduation-certificate-setting${id?'/'+id:''}`,
            method: 'put',
            data: query,
        })
    }
lookups(yearId) {
  return request({
    url: `/certificates_dates/lookups/${yearId}`,
    method: 'get',
    params: {
      type: true,
    }
  });
}

}

export {Settings as default};
